// import Nav from "../Nav";
import "../style/dashboard/Dashboard.css";
import ADS from "./ADS";
import DateBox from "./DateBox";
import ExamResults from "./ExamResults";
import SidSlider from "./Sid_Slider";
import ads_img1 from "../../assets/dashboard/ads/ads1.png";
import Search from "./Search";
import MyExamList from "./MyExamList";
import ExamStore from "./ExamStore";
import Weblog from "./Weblog";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const Dashboard = () => {
  // console.log("dash render---------------------");

  const state = useSelector((state) => state.default);

  useEffect(() => {
    // console.log(window.innerWidth);
    if (state.openNav === "open") {
      document.querySelector(".dashboard-main").style.width = "52.76%";
      if (window.innerWidth < 1355) {
        document.querySelector(".dashboard-main").style.width = "52%";
      }
    } else if (state.openNav === "close") {
      document.querySelector(".dashboard-main").style.width = "65%";
      if (window.innerWidth < 1458) {
        document.querySelector(".dashboard-main").style.width = "64%";
      }
      if (window.innerWidth < 1368) {
        document.querySelector(".dashboard-main").style.width = "63%";
        // console.log("lllllllllllll");
      }
      if (window.innerWidth < 1200) {
        document.querySelector(".dashboard-main").style.width = "61%";
        // console.log("hhhhhhhhhhhh");
      }
    }
  });
  return (
    <div className="dashboard">
      <div className="sidebar">
        <DateBox />
        <ExamResults />
        <SidSlider />
        <ADS img={ads_img1} title="من اینجا هستم" subtitle="ADVERTISING" />
      </div>
      <div className="dashboard-main">
        {/* <Search /> */}
        <MyExamList />
        <ExamStore />
        <Weblog />
      </div>
    </div>
  );
};

export default Dashboard;
